import Flex from '@/components/common/Flex';
import classNames from 'classnames';
import Select from 'react-select';
import { Alert, Form, Tab } from 'react-bootstrap';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useFormikContext } from 'formik';
import type { OptionProps } from 'react-select';

import type { TrackerSettings } from '../types';

interface NotificationFormValues extends Pick<
  TrackerSettings,
  | 'enable_notification_by_email'
  | 'enable_notification_by_telegram'
  | 'enable_notification_by_bale'
  | 'notif_via_email_to_access_levels'
  | 'notif_via_telegram_to_access_levels'
  | 'notif_via_bale_to_access_levels'
  | 'inputValue'
> {}

const Notifications = () => {
  const { data: userInfo } = useGetUserInfoQuery();
  const { values, setFieldValue, errors } =
    useFormikContext<NotificationFormValues>();
  return (
    <Tab.Pane className="my-3" eventKey="notificationSettings">
      <h5 className="fw-bold mt-5 my-3 fs-0">تنظیمات اطلاع‌رسانی</h5>
      <Flex direction="column">
        <div className="mb-3">
          <div
            className={`${!userInfo.data.email_verified && 'disabled-link'}`}
          >
            <div className="d-flex gap-2 align-items-center">
              <Form.Check
                type="checkbox"
                id="11"
                checked={values.enable_notification_by_email}
                onChange={({ target }) => {
                  setFieldValue('enable_notification_by_email', target.checked);
                }}
                label={
                  <div className="fs--1 cursor-pointer">
                    فعال کردن اطلاع رسانی از طریق ایمیل{' '}
                  </div>
                }
              />
            </div>
            <div
              className={`d-flex flex-column align-items-start fs--1 ${!values.enable_notification_by_email && 'disabled-link'}`}
            >
              <Form.Label htmlFor="55">
                اطلاع‌رسانی از طریق ایمیل به همکاران با سطح دسترسی
              </Form.Label>
              <div
                className="mb-2"
                style={{
                  width: 275
                }}
              >
                <Select
                  classNamePrefix="react-select"
                  menuShouldScrollIntoView={true}
                  inputValue={values.inputValue}
                  closeMenuOnSelect={false}
                  placeholder="انتخاب کن"
                  isDisabled={!values.enable_notification_by_email}
                  styles={{
                    menu: () => ({
                      position: 'absolute',
                      zIndex: 9999,
                      width: '100%'
                    }),
                    control: baseStyles => ({
                      ...baseStyles,
                      direction: 'rtl !important',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important',
                      borderRadius: '5px 5px 5px 5px !important',
                      width: '100% !important',
                      cursor: 'pointer',
                      borderColor:
                        errors.notif_via_email_to_access_levels &&
                        'var(--falcon-form-invalid-border-color) !important'
                    }),
                    input: baseStyles => ({
                      ...baseStyles,
                      direction: 'ltr !important',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important'
                    })
                  }}
                  components={{
                    Option: OptionLayout
                  }}
                  onChange={e => {
                    setFieldValue(
                      'notif_via_email_to_access_levels',
                      e.map(e => e.value)
                    );
                  }}
                  isMulti
                  value={values.notif_via_email_to_access_levels?.map(e => ({
                    label: accessMap[e],
                    value: e
                  }))}
                  isSearchable={true}
                  noOptionsMessage={() => 'یافت نشد'}
                  options={[
                    { label: 'مالک', value: '1' },
                    { label: 'مدیر', value: '2' },
                    { label: 'دیدن', value: '3' }
                  ]}
                />
                <Form.Control.Feedback
                  className="d-block"
                  type={
                    errors.notif_via_email_to_access_levels
                      ? 'invalid'
                      : 'valid'
                  }
                >
                  {errors.notif_via_email_to_access_levels}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          {!userInfo?.data?.email_verified && (
            <Alert
              variant={'warning'}
              className={'d-flex align-items-center fs--1 p-2'}
            >
              <div>
                برای اینکه این بخش برات فعال بشه، اول باید ایمیلت رو تأیید کنی.
                جهت تایید ایمیل روی{' '}
                <a
                  href="https://accounts.binesh-ec.com/email"
                  style={{ textDecoration: 'underline' }}
                  target="_blank"
                >
                  {' '}
                  این لینک{' '}
                </a>
                کلیک کن
              </div>
            </Alert>
          )}
        </div>

        <div className="mb-3">
          <div className={`${!userInfo.data.join_telegram && 'disabled-link'}`}>
            <div className="d-flex gap-2 align-items-center">
              <Form.Check
                type="checkbox"
                id="22"
                checked={values.enable_notification_by_telegram}
                onChange={({ target }) => {
                  setFieldValue(
                    'enable_notification_by_telegram',
                    target.checked
                  );
                }}
                label={
                  <div className="fs--1 cursor-pointer">
                    فعال کردن اطلاع رسانی از طریق تلگرام{' '}
                  </div>
                }
              />
            </div>

            <div
              className={`d-flex flex-column align-items-start fs--1 ${!values.enable_notification_by_telegram && 'disabled-link'}`}
            >
              <Form.Label htmlFor="55">
                اطلاع‌رسانی از طریق تلگرام به همکاران با سطح دسترسی
              </Form.Label>
              <div
                className="mb-2"
                style={{
                  width: 275
                }}
              >
                <Select
                  classNamePrefix="react-select"
                  menuShouldScrollIntoView={true}
                  inputValue={values.inputValue}
                  closeMenuOnSelect={false}
                  isDisabled={!values.enable_notification_by_telegram}
                  placeholder="انتخاب کن"
                  styles={{
                    menu: () => ({
                      position: 'absolute',
                      zIndex: 9999,
                      width: '100%'
                    }),
                    control: baseStyles => ({
                      ...baseStyles,
                      direction: 'rtl !important',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important',
                      borderRadius: '5px 5px 5px 5px !important',
                      width: '100% !important',
                      cursor: 'pointer',
                      borderColor:
                        errors.notif_via_telegram_to_access_levels &&
                        'var(--falcon-form-invalid-border-color) !important'
                    }),
                    input: baseStyles => ({
                      ...baseStyles,
                      direction: 'ltr !important',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important'
                    })
                  }}
                  components={{
                    Option: OptionLayout
                  }}
                  onChange={e => {
                    setFieldValue(
                      'notif_via_telegram_to_access_levels',
                      e.map(e => e.value)
                    );
                  }}
                  isMulti
                  value={values.notif_via_telegram_to_access_levels?.map(e => ({
                    label: accessMap[e],
                    value: e
                  }))}
                  isSearchable={true}
                  noOptionsMessage={() => 'یافت نشد'}
                  options={[
                    { label: 'مالک', value: '1' },
                    { label: 'مدیر', value: '2' },
                    { label: 'دیدن', value: '3' }
                  ]}
                />
                <Form.Control.Feedback
                  className="d-block"
                  type={
                    errors.notif_via_telegram_to_access_levels
                      ? 'invalid'
                      : 'valid'
                  }
                >
                  {errors.notif_via_telegram_to_access_levels}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          {!userInfo?.data?.join_telegram && (
            <Alert
              variant={'warning'}
              className={'d-flex align-items-center fs--1 p-2'}
            >
              <div>
                برای اینکه این بخش برات فعال بشه، اول باید ربات تلگرام رو فعال
                کنی. جهت فعال سازی روی{' '}
                <a
                  href="https://accounts.binesh-ec.com/telegram"
                  style={{ textDecoration: 'underline' }}
                  target="_blank"
                >
                  این لینک
                </a>{' '}
                کلیک کن
              </div>
            </Alert>
          )}
        </div>

        <div className="mb-3">
          <div className={`${!userInfo.data.join_bale && 'disabled-link'}`}>
            <div className="d-flex gap-2 align-items-center">
              <Form.Check
                type="checkbox"
                id="33"
                checked={values.enable_notification_by_bale}
                onChange={({ target }) => {
                  setFieldValue(
                    'enable_notification_by_bale',
                    target.checked
                  );
                }}
                label={
                  <div className="fs--1 cursor-pointer">
                    فعال کردن اطلاع رسانی از طریق بله{' '}
                  </div>
                }
              />
            </div>

            <div
              className={`d-flex flex-column align-items-start fs--1 ${!values.enable_notification_by_bale && 'disabled-link'}`}
            >
              <Form.Label htmlFor="55">
                اطلاع‌رسانی از طریق بله به همکاران با سطح دسترسی
              </Form.Label>
              <div
                className="mb-2"
                style={{
                  width: 275
                }}
              >
                <Select
                  classNamePrefix="react-select"
                  menuShouldScrollIntoView={true}
                  inputValue={values.inputValue}
                  closeMenuOnSelect={false}
                  isDisabled={!values.enable_notification_by_bale}
                  placeholder="انتخاب کن"
                  styles={{
                    menu: () => ({
                      position: 'absolute',
                      zIndex: 9999,
                      width: '100%'
                    }),
                    control: baseStyles => ({
                      ...baseStyles,
                      direction: 'rtl !important',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important',
                      borderRadius: '5px 5px 5px 5px !important',
                      width: '100% !important',
                      cursor: 'pointer',
                      borderColor:
                        errors.notif_via_bale_to_access_levels &&
                        'var(--falcon-form-invalid-border-color) !important'
                    }),
                    input: baseStyles => ({
                      ...baseStyles,
                      direction: 'ltr !important',
                      color: 'var(--falcon-emphasise) !important',
                      boxShadow: 'none !important'
                    })
                  }}
                  components={{
                    Option: OptionLayout
                  }}
                  onChange={e => {
                    setFieldValue(
                      'notif_via_bale_to_access_levels',
                      e.map(e => e.value)
                    );
                  }}
                  isMulti
                  value={values.notif_via_bale_to_access_levels?.map(e => ({
                    label: accessMap[e],
                    value: e
                  }))}
                  isSearchable={true}
                  noOptionsMessage={() => 'یافت نشد'}
                  options={[
                    { label: 'مالک', value: '1' },
                    { label: 'مدیر', value: '2' },
                    { label: 'دیدن', value: '3' }
                  ]}
                />
                <Form.Control.Feedback
                  className="d-block"
                  type={
                    errors.notif_via_bale_to_access_levels
                      ? 'invalid'
                      : 'valid'
                  }
                >
                  {errors.notif_via_bale_to_access_levels}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          {!userInfo?.data?.join_bale && (
            <Alert
              variant={'warning'}
              className={'d-flex align-items-center fs--1 p-2'}
            >
              <div>
                برای اینکه این بخش برات فعال بشه، اول باید ربات بله رو فعال
                کنی. جهت فعال سازی روی{' '}
                <a
                  href="https://accounts.binesh-ec.com/bale"
                  style={{ textDecoration: 'underline' }}
                  target="_blank"
                >
                  این لینک
                </a>{' '}
                کلیک کن
              </div>
            </Alert>
          )}
        </div>
      </Flex>
    </Tab.Pane>
  );
};

export default Notifications;

const OptionLayout = (props: OptionProps<{ label: string; value: string }>) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
          `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className={classNames(
          'p-2 cursor-pointer border border-1 customized-searchbox-option',
          {}
        )}
      >
        <div className="fs-0 text-900">{props.data.label}</div>
      </div>
    </>
  );
};

const accessMap: Record<string, string> = {
  1: 'مالک',
  2: 'مدیر',
  3: 'دیدن'
};
